export const monthTotalOnMainSheet = (
  cell: any,
  field: string,
  monthSheetColumn: string,
) => {
  cell.value = {
    formula: `'${field}'!${monthSheetColumn}2`,
  };
  return cell;
};
